export default {
  title: 'Etape 2 : Remplir les paramètres',
  back_link: {
    route: 'Configurator_Step1',
    text: "Retour à l'étape 1",
  },
  button: 'Valider les paramètres',
};
